import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { USER_PREFERENCE_SETS } from 'common/utils/constants';
import { setDropModalOpen } from 'redux/actions';
import { selectUserPreferences } from 'redux/selectors';
import { selectUserCategoryPreferences, selectUserPreference } from 'redux/UserPreferences';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { ProgressIndicator } from 'components/shared/Progress';
import { fallbackByCategory } from '../../constants';
import styles from './ChartPreferenceMenu.module.css';

const fallbackIds = fallbackByCategory[USER_PREFERENCE_SETS.CHART];

function ChartPreferenceMenu({ onSelect, dropModalName }) {
  const { loading, ids } = useSelector((state) =>
    selectUserCategoryPreferences(selectUserPreferences(state), USER_PREFERENCE_SETS.CHART)
  );

  const sortedIds = useSelector((state) =>
    [...ids, ...fallbackIds]
      .map((preferenceId) => selectUserPreference(selectUserPreferences(state), preferenceId))
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((preference) => preference.preferenceId)
  );

  return (
    <div className={styles.menu}>
      <PerfectScrollbar>
        {loading && (
          <div className={styles.progressbar}>
            <ProgressIndicator />
          </div>
        )}
        <div className={styles.menuList}>
          {sortedIds.map((id) => (
            <ChartMenuItem key={id} preferenceId={id} onClick={onSelect} dropModalName={dropModalName} />
          ))}
        </div>
      </PerfectScrollbar>
    </div>
  );
}

export default ChartPreferenceMenu;

function ChartMenuItem({ preferenceId, onClick, dropModalName }) {
  const dispatch = useDispatch();
  const preference = useSelector((state) => selectUserPreference(selectUserPreferences(state), preferenceId));
  const handleClick = () => {
    const meta = {
      preferenceId: preferenceId,
      category: preference.category,
      local: preference.local ?? false,
      query: { actions: ['reboot'] }
    };

    onClick(meta);
    dispatch(setDropModalOpen(dropModalName, false));
  };

  return (
    <div className={styles.menuItem} onClick={handleClick}>
      {preference.name}
    </div>
  );
}
